import { InputNumber, TableProps } from "antd"
import { ICampaignResult } from "../types/sbCampaignApi.types"
import useSearchColumn from "../../../hooks/useSearchColumn"
import { columnsWidth, EXPAND_COLUMN_WIDTH } from "../constants/columns.constants"
import { ITargetDataForTable } from "../types/sbTarget.types"

export const useTargetsColumns = (
  changeTargetAcos: (targetId: string, value: number) => void,
  changeLimitedCPC: (targetId: string, value: number) => void
): TableProps<ITargetDataForTable>["columns"] => {
  const searchColumnCampaignName = useSearchColumn<ITargetDataForTable>({ dataIndex: "targetName" })

  const columns: TableProps<ITargetDataForTable>["columns"] = [
    {
      // Spacer that mirrors the parent table's expand-icon column so both
      // tables share the same fixed grid (selection 48 + 48 + data columns).
      title: "",
      key: "expandSpacer",
      width: EXPAND_COLUMN_WIDTH,
      render: () => null,
    },
    {
      title: "Target ACOS",
      width: columnsWidth[0],
      align: "center",
      render: (target) => (
        <InputNumber
          onChange={(value) => changeTargetAcos(target.targetId, Number(value))}
          style={{ textAlign: "center" }}
          value={target.targetAcos}
          min={0}
          max={100}
        />
      ),
    },
    {
      title: "Active",
      width: columnsWidth[1],
      align: "center",
      render: (row: ICampaignResult) => "",
    },
    {
      title: "Campaigns",
      dataIndex: "targetName",
      key: "targetName",
      width: columnsWidth[2],
      ...searchColumnCampaignName,
    },
    {
      title: "Target CPC in amazon",
      dataIndex: "bid",
      width: columnsWidth[3],
      align: "center",
      key: "bid",
      render: (bid) => (bid == null ? "-" : "$" + bid),
    },
    {
      title: "Target CPC",
      dataIndex: "targetCPC",
      key: "targetCPC",
      width: columnsWidth[4],
      align: "center",
      render: (targetCPC) => (targetCPC == null ? "-" : "$" + targetCPC),
    },
    {
      title: "Best CPC",
      dataIndex: "bestCPC",
      width: columnsWidth[5],
      align: "center",
      key: "bestCPC",
      render: (bestCPC) => (bestCPC == null ? "-" : "$" + bestCPC),
    },
    {
      title: "Limited CPC",
      width: columnsWidth[6],
      align: "center",
      key: "limitedCPC",
      render: (target) => (
        <InputNumber
          onChange={(value) => changeLimitedCPC(target.targetId, Number(value))}
          style={{ textAlign: "center" }}
          value={target.limitedCPC ?? 0}
          precision={2}
          min={0}
          max={100}
        />
      ),
    },
    {
      title: "Deflated CPC",
      dataIndex: "deflatedCPC",
      width: columnsWidth[7],
      align: "center",
      key: "deflatedCPC",
      render: (deflatedCPC) => (deflatedCPC == null ? "-" : "$" + deflatedCPC),
    },
    {
      title: "Impressions",
      dataIndex: "impressions",
      align: "start",
      width: columnsWidth[8],
      key: "impressions",
    },
    {
      title: "Clicks",
      dataIndex: "clicks",
      key: "clicks",
      align: "start",
      width: columnsWidth[9],
    },
    {
      title: "CTR",
      dataIndex: "ctr",
      key: "ctr",
      align: "start",
      width: columnsWidth[10],
      render: (ctr) => ctr + "%",
    },
    {
      title: "Spend",
      dataIndex: "spend",
      key: "spend",
      align: "center",
      width: columnsWidth[11],
      render: (spend) => "$" + spend,
    },
    {
      title: "Sales",
      dataIndex: "sales",
      key: "sales",
      align: "center",
      width: columnsWidth[12],
      render: (sales) => "$" + sales,
    },
    {
      title: "Orders",
      dataIndex: "orders",
      key: "orders",
      align: "end",
      width: columnsWidth[13],
    },
    {
      title: "Units",
      dataIndex: "units",
      key: "units",
      align: "end",
      width: columnsWidth[14],
    },
    {
      title: "CVR",
      dataIndex: "cvr",
      key: "cvr",
      align: "end",
      width: columnsWidth[15],
      render: (cvr) => cvr + "%",
    },
    {
      title: "ACOS",
      dataIndex: "acos",
      key: "acos",
      align: "end",
      width: columnsWidth[16],
      render: (acos) => acos + "%",
    },
    {
      title: "CPC",
      dataIndex: "cpc",
      key: "cpc",
      align: "end",
      width: columnsWidth[17],
      render: (cpc) => (cpc == null ? "-" : "$" + cpc),
    },
    {
      title: "ROAS",
      dataIndex: "roas",
      key: "roas",
      align: "center",
      width: columnsWidth[18],
      render: (roas) => roas ?? "-",
    },
  ]

  return columns
}
